// @ts-nocheck
import api from './axios';

/**
 * Request a short-lived signed URL for viewing a PHI document.
 *
 * The server performs the permission check, writes a HIPAA-compliant
 * DocumentAccessLog row, emits a structured `phi.document.access` log line,
 * and returns a V4 signed URL that expires in 15 minutes. The in-app
 * PdfViewerModal owns this request lifecycle and renders the URL in an iframe.
 *
 * Never cache the returned URL — it grants direct PHI access. Re-request
 * per view/refresh so each issued URL is independently audited.
 *
 * See backend: documents/services/signed_url_service.py
 * See backend route: documents/urls.py — `document-view-url`
 *
 * @param {('eob'|'lmn')} documentType
 * @param {string} documentId UUID of the UploadedDocument
 * @returns {Promise<{url: string, expires_at: string}>}
 */
export const requestSignedView = (documentType, documentId) =>
  api
    .post(`/documents/${documentType}/${documentId}/view-url/`)
    .then((r) => r.data);
